// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"4816b0c2","208":"7b1b5194","209":"9e42c141","717":"76e6e121","787":"35ac66da"}[chunkId] + ".chunk.js";
};